// export const ENDPOINT = "http://localhost:80";
export const ENDPOINT = "http://3.80.87.176";
